var React = require('react');

function OneoffNumberedList (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41 15l-4 1-13 5c-4 1-4 2-4 6 0 5 1 5 6 2 6-3 6-2 6 19v19h12V41c0-19-1-26-2-27l-1 1zM68 39v7l1 4 33 1 34-1V39c-2-2-67-2-68 0zM26 84c-5 2-8 6-10 11-1 4 0 5 6 5 5 0 7-1 7-4 0-2 3-5 6-5s5 6 4 10c-2 4-2 5-14 18-8 8-8 9-8 12v5h36v-8l-9-1c-7 0-9-1-9-2l7-9 9-11c2-5 1-12-2-16-4-7-15-9-23-5zM69 101l-1 6 1 5 33 1 34-1c2-2 1-10 0-11H69z"}));
}

OneoffNumberedList.displayName = "OneoffNumberedList";

OneoffNumberedList.defaultProps = {"version":"1","width":"200","height":"200","viewBox":"0 0 150 150"};

module.exports = OneoffNumberedList;

OneoffNumberedList.default = OneoffNumberedList;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/oneoff-numbered-list.svg
// module id = 776
// module chunks = 0